module.exports = __webpack_public_path__ + "media/prom_2.b9ce3175.mp3";